import React from 'react'
import { Link } from '@fs/zion-router'
import { Ellipsis } from '@fs/zion-ui'

export default function TreeNameOrFileTitle({ title, name, id }) {
  const content = name || title
  return id ? (
    <Ellipsis lineClamp={2}>
      <Link to={`/research-tree/${id}`} data-testid="uploadName">
        {content}
      </Link>
    </Ellipsis>
  ) : (
    <Ellipsis lineClamp={2}>
      <div data-testid="uploadName">{content}</div>
    </Ellipsis>
  )
}
